import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { MediaService } from "src/app/main/services/media.service";
import { Media } from "src/app/models/media";
import { MediaClass } from "src/app/models/media-class";
import { ApplicationPool } from "src/app/services/application.pool";
import { environment } from "src/environments/environment";

@Component({
  selector: "media-signature",
  templateUrl: "./media-signature.component.html",
  styleUrls: ["./media-signature.component.scss"]
})
export class MediaSignatureComponent implements OnInit {
  @Input() public media: Media;

  constructor(
    private dataPool: ApplicationPool,
    private mediaService: MediaService
  ) {}

  ngOnInit(): void {}
  ngAfterViewInit(): void {}

  getIsbnUrl(media: Media) {
    return environment.production
      ? "/antolin/" + media.isbn
      : "http://localhost/antolin/" + media.isbn;
  }

  get Author() {
    return this.mediaService.getAuthorSignature(this.media);
  }

  getTextColor(mediaClass: MediaClass) {
    if (this.signatureTextBackground && mediaClass.color) {
      const hex = mediaClass.color.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance < 0.5 ? "#fff" : "#000";
    }
    return "#fff";
  }

  get signatureColorRectangle() {
    return (
      this.dataPool.Library.configuration?.printSignatureRectangle || false
    );
  }
  get signatureTextBackground() {
    return (
      this.dataPool.Library.configuration
        ?.printClassBackgroundOnSignatureSticker || false
    );
  }

  get printAntolinIcon() {
    return (
      this.dataPool.Library.configuration?.printAntolinIconOnSignatureSticker ||
      false
    );
  }
  get printSeries() {
    return (
      this.dataPool.Library.configuration?.printSeriesOnSignatureSticker ||
      false
    );
  }
  get printId() {
    return this.dataPool.Library.configuration?.printMediaIdOnSignatureSticker;
  }
  get hasSeries() {
    return this.media.volume && this.media.volume.length > 0;
  }
  get series() {
    const str = this.media.volume.match(/(\d+)/);
    if (str && str.length > 0) return str[0];
    return "";
  }

  get useBigSignatureStickerMode() {
    return (
      this.dataPool.Library.configuration?.useBigSignatureStickerMode || false
    );
  }
}
